import { UIWidgetsDiv } from "../../common/ui/widgets/division/Division";
import { PopupWrapper } from "../styles";

export const Popup = ({ closePopup, children }) => {
    return (
      <PopupWrapper>
        <UIWidgetsDiv 
        data-testid="closePopup"
        onClick={closePopup} />
        {children}
      </PopupWrapper>
    );
};